import English from "@/locales/English";
import German from "@/locales/German";

const LanguageSchema = {
	de: German,
	en: English,
};

export default LanguageSchema;
